import React, { useEffect, useRef, useState } from "react";
import { CircularProgress, Icon, Button } from "@material-ui/core";
import { apiErrorMessage } from "../../helpers/apiErrorMessage";
import "./Subscription.css";

const StripeReturnHandler = ({ sessionId, pollStripeSession, onComplete, onError }) => {
	const [status, setStatus] = useState("verifying"); // verifying | success | error
	const [errorMessage, setErrorMessage] = useState("");
	const startedRef = useRef(false);
	const onCompleteRef = useRef(onComplete);
	onCompleteRef.current = onComplete;

	useEffect(() => {
		if (!sessionId || startedRef.current) return;
		startedRef.current = true;

		pollStripeSession(
			sessionId,
			() => {
				setStatus("success");
				setTimeout(() => {
					if (onCompleteRef.current) onCompleteRef.current();
				}, 2500);
			},
			(err) => {
				setStatus("error");
				setErrorMessage(
					apiErrorMessage(
						err,
						"Something went wrong verifying your payment. If you were charged, refresh this page in a minute before trying again."
					)
				);
			}
		);
	}, [sessionId, pollStripeSession]);

	return (
		<div className="subscription-page">
			<div style={{
				textAlign: "center",
				padding: "4rem 2rem",
				maxWidth: 480,
				margin: "0 auto",
			}}>
				{status === "verifying" && (
					<>
						<CircularProgress size={48} style={{ color: "#635BFF", marginBottom: "1.5rem" }} />
						<h2 style={{ color: "#1a2332", fontWeight: 600, marginBottom: "0.5rem" }}>
							Verifying your payment...
						</h2>
						<p style={{ color: "#6B7C93", fontSize: "0.938rem", lineHeight: 1.6 }}>
							Please wait while we confirm your subscription with Stripe. This usually takes a few seconds.
						</p>
					</>
				)}

				{status === "success" && (
					<>
						<Icon style={{ fontSize: "3rem", color: "#2E7D32", marginBottom: "1rem" }}>
							check_circle
						</Icon>
						<h2 style={{ color: "#1a2332", fontWeight: 600, marginBottom: "0.5rem" }}>
							Subscription Created!
						</h2>
						<p style={{ color: "#6B7C93", fontSize: "0.938rem", lineHeight: 1.6 }}>
							Your payment was successful. Redirecting you back to your subscription...
						</p>
					</>
				)}

				{status === "error" && (
					<>
						<Icon style={{ fontSize: "3rem", color: "#C62828", marginBottom: "1rem" }}>
							error
						</Icon>
						<h2 style={{ color: "#1a2332", fontWeight: 600, marginBottom: "0.5rem" }}>
							Verification Issue
						</h2>
						<p style={{ color: "#6B7C93", fontSize: "0.938rem", lineHeight: 1.6, marginBottom: "1.5rem" }}>
							{errorMessage}
						</p>
						<Button
							variant="contained"
							color="primary"
							onClick={onError}
							style={{ textTransform: "none", fontWeight: 600 }}
						>
							Back to Subscription
						</Button>
					</>
				)}
			</div>
		</div>
	);
};

export default StripeReturnHandler;
